import {
  GridColumn as Column,
  GridColumnProps,
  GridPageChangeEvent,
  GridSortChangeEvent,
} from "@progress/kendo-react-grid";
import "@progress/kendo-theme-default/dist/all.css";
import { CompositeFilterDescriptor, SortDescriptor } from "@progress/kendo-data-query";
import { forwardRef, useEffect, useState } from "react";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import { StyledSortableGrid } from "./StyledSortableGrid";

interface Props {
  dataItemKey: string;
  columns: GridColumnProps[];
  data: any[];
  showLoader?: boolean;
  filter?: CompositeFilterDescriptor;
}

export const DataGridWithSort = forwardRef<ExcelExport, Props>(
  ({ dataItemKey, columns, data, showLoader, filter }, ref) => {
    const [page, setPage] = useState({ skip: 0, take: 20 });
    const [sort, setSort] = useState<SortDescriptor[]>([]);

    const handlePageChange = (event: GridPageChangeEvent) => {
      setPage(event.page);
    };

    const handleSortChange = (event: GridSortChangeEvent) => {
      setSort(event.sort);
      setPage((prev) => ({ ...prev, skip: 0 }));
    };

    useEffect(() => {
      setPage((prev) => ({ ...prev, skip: 0 }));
    }, [filter]);

    return (
      <>
        <ExcelExport ref={ref}>
          <StyledSortableGrid
            data={data}
            dataItemKey={dataItemKey}
            autoProcessData={true}
            sortable={true}
            sort={sort}
            onSortChange={handleSortChange}
            showLoader={showLoader}
            filter={filter}
            scrollable="scrollable"
            pageable={{ buttonCount: 5, pageSizes: [10, 20, 30], info: true }}
            skip={page.skip}
            take={page.take}
            onPageChange={handlePageChange}
          >
            {columns.map((columnProps) => (
              <Column
                key={columnProps.title}
                {...columnProps}
              />
            ))}
          </StyledSortableGrid>
        </ExcelExport>
      </>
    );
  }
);
